/* Cleanly - comparison slider interaction fix
 * 1) RTL: the native range input inherits dir=rtl from <body>, which mirrors it.
 *    We take pointer control ourselves and force the input to ltr for keyboard.
 * 2) The theme's intro animation sets isAnimating=true for 1.6s and then hard
 *    resets the value to 50 - if the user drags while it runs, nothing moves.
 *    We make the animation interruptible and cancel it on first touch.
 * 3) Touch: horizontal drag now controls the slider, vertical drag still scrolls.
 */
(function () {
  'use strict';

  var WRAP = '.comparison-slider__media-wrapper';
  var drag = null;

  function component(w) {
    return w.closest ? w.closest('comparison-slider-component') : null;
  }

  function isVertical(w) {
    return w.getAttribute('data-orientation') === 'vertical';
  }

  function toPercent(w, x, y) {
    var r = w.getBoundingClientRect();
    if (!r.width || !r.height) return null;
    var p = isVertical(w) ? (1 - (y - r.top) / r.height) * 100 : ((x - r.left) / r.width) * 100;
    if (p < 0) p = 0;
    if (p > 100) p = 100;
    return Math.round(p);
  }

  function apply(w, p) {
    if (p === null) return;
    var c = component(w);
    if (c) {
      if (c.__clTimers) {
        c.__clTimers.forEach(function (t) { clearTimeout(t); });
        c.__clTimers = null;
      }
      c.hasAnimated = true;
      c.isAnimating = false;
    }
    w.style.setProperty('--transition-duration', '0s');
    var input = w.querySelector('input.cs-slider');
    if (input) input.value = String(p);
    w.style.setProperty('--compare', String(p));
  }

  function wrapperFrom(target) {
    if (!target || !target.closest) return null;
    return target.closest(WRAP);
  }

  document.addEventListener(
    'pointerdown',
    function (e) {
      var w = wrapperFrom(e.target);
      if (!w) return;
      drag = { w: w, id: e.pointerId, x0: e.clientX, y0: e.clientY, active: false, vert: isVertical(w) };
      // Mouse / pen: jump immediately. Touch: wait for a real drag so page scroll still works.
      if (e.pointerType !== 'touch') {
        drag.active = true;
        try { w.setPointerCapture(e.pointerId); } catch (err) {}
        apply(w, toPercent(w, e.clientX, e.clientY));
      }
    },
    true
  );

  document.addEventListener(
    'pointermove',
    function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      if (!drag.active) {
        var dx = Math.abs(e.clientX - drag.x0);
        var dy = Math.abs(e.clientY - drag.y0);
        var main = drag.vert ? dy : dx;
        var cross = drag.vert ? dx : dy;
        if (main < 6) return;
        if (cross > main) { drag = null; return; } // user is scrolling, let go
        drag.active = true;
        try { drag.w.setPointerCapture(e.pointerId); } catch (err) {}
      }
      apply(drag.w, toPercent(drag.w, e.clientX, e.clientY));
      if (e.cancelable) e.preventDefault();
    },
    { capture: true, passive: false }
  );

  function endDrag(e) {
    if (drag && (!e || e.pointerId === drag.id)) drag = null;
  }
  document.addEventListener('pointerup', endDrag, true);
  document.addEventListener('pointercancel', endDrag, true);

  /* Make the theme's intro animation cancellable. */
  function patchClass() {
    var C = window.customElements && customElements.get('comparison-slider-component');
    if (!C) return false;
    if (C.__clPatched) return true;
    C.__clPatched = true;
    C.prototype.animateSlider = function () {
      var self = this;
      var refs = self.refs || {};
      var w = refs.mediaWrapper;
      var s = refs.slider;
      if (!w || self.hasAnimated) return;
      self.hasAnimated = true;
      self.isAnimating = true;
      self.__clTimers = [];
      w.style.setProperty('--transition-duration', '0.5s');
      function at(ms, fn) { self.__clTimers.push(setTimeout(fn, ms)); }
      at(100, function () { w.style.setProperty('--compare', '40'); });
      at(600, function () { w.style.setProperty('--compare', '60'); });
      at(1100, function () { w.style.setProperty('--compare', '50'); });
      at(1600, function () {
        w.style.setProperty('--transition-duration', '0s');
        if (s) s.value = '50';
        self.isAnimating = false;
        self.__clTimers = null;
      });
    };
    return true;
  }

  if (!patchClass()) {
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (patchClass() || tries > 100) clearInterval(iv);
    }, 50);
  }

  /* Safety net for old browsers without Pointer Events. */
  if (!window.PointerEvent) {
    var t = null;
    document.addEventListener('touchstart', function (e) {
      var w = wrapperFrom(e.target);
      if (!w) return;
      t = { w: w, x0: e.touches[0].clientX, y0: e.touches[0].clientY, active: false, vert: isVertical(w) };
    }, true);
    document.addEventListener('touchmove', function (e) {
      if (!t) return;
      var p = e.touches[0];
      if (!t.active) {
        var dx = Math.abs(p.clientX - t.x0), dy = Math.abs(p.clientY - t.y0);
        var main = t.vert ? dy : dx, cross = t.vert ? dx : dy;
        if (main < 6) return;
        if (cross > main) { t = null; return; }
        t.active = true;
      }
      apply(t.w, toPercent(t.w, p.clientX, p.clientY));
      if (e.cancelable) e.preventDefault();
    }, { capture: true, passive: false });
    document.addEventListener('touchend', function () { t = null; }, true);
  }
})();
